import { createAction, props } from "@ngrx/store";

export const fetchCampaign = createAction(
  "[Campaign] Fetch",
  props<{ page, filterOptions }>()
);

export const fetchCampaignSuccess = createAction(
  "[Campaign] Fetch Success",
  props<{ campaign }>()
);

export const fetchCampaignFailure = createAction(
  "[Campaign] Fetch Faild",
  props<{ error }>()
);

export const getCampaign = createAction(
  "[Campaign] Get",
  props<{ id }>()
);

export const getCampaignSuccess = createAction(
  "[Campaign] Get Success",
  props<{ campaign }>()
);

export const getCampaignFailure = createAction(
  "[Campaign] Get Failure",
  props<{ error }>()
);

export const fetchInvolvedCampaigns = createAction(
  "[Campaign] Fetch By Affiliate",
);

export const fetchInvolvedCampaignsSuccess = createAction(
  "[Campaign] Fetch By Affiliate Success",
  props<{ campaigns }>()
);

export const fetchInvolvedCampaignsFailure = createAction(
  "[Campaign] Fetch By Affiliate Faild",
  props<{ error }>()
);